<template>
<div ref = "services" class = "services-area">
    
    
    <div class = "section is-size-2-desktop is-size-3 has-text-black-ter title-font has-text-weight-bold">
      ¡Pide presupuesto sin compromiso!
    </div>

    
    
    <div class = "is-desktop-half columns is-centered fix-white-margin-columns">
      <div class = "column is-6">
        <p class = "is-size-4-desktop is-size-5">
        Cuéntanos tu proyecto de toldos
        </p>
      </div>
    </div>
    
    <br>
    
    
    <div class = "columns is-centered fix-white-margin-columns">
      <div class = "column is-flex image-center" >
        <figure class = "image image-side" style = "margin: 1rem;">
          <img src = "../../public/fotos/2.jpg"/>
        </figure>
        
      </div>
      <div class = "column is-narrow">
        <div class = "has-text-left">
          <ul class = "list-style is-size-5" style = "list-style-type:disc">
            <li> Cambiar tela de toldo </li>
            <li> Instalar toldo en local comercial </li>
            <li> Instalar toldo en vivienda </li>
            <li> Pergolas </li>
            <li> Reparar toldo </li>
            <li> Otros trabajos de toldos </li>
            <li> Toldo piscina </li>
          </ul>
        </div>
        
      </div>
      
      <div class = "column is-flex image-center">
        <figure class = "image image-side" style = "margin: 1rem;">
          <img src = "../../public/fotos/3.jpg" />
        </figure>
      </div>
    </div> 
    
    <br>
    
</div>
</template>

<script>

//import {requester} from '../App.vue';
//import _ from 'lodash';

export default {
  name: 'Services',
  data() {
    return { 
      name: ""
    }
  },
  methods: {
    goTo: function(){
      var element = this.$refs["services"];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.services-area {
  background-color: #B4D9ED;
}
.list-area {
  background-color: rgb(147, 189, 212);
}

.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.list-style {
  list-style-position: inside;
  padding: 2px;
}
.image.is-256x256 {
  height: 256px;
  width: 256px;
}

.image.image-side {
  height: 270px;
  width: 480px;
}

.image-center {
  justify-content: center;
}

.fix-white-margin-columns {
  margin-right: 0px !important;
}

</style>

